// extracted by mini-css-extract-plugin
module.exports = {"section":"IrregularBackgroundAndText_section__waLuL","textWrapper":"IrregularBackgroundAndText_textWrapper__97tes","text":"IrregularBackgroundAndText_text__3r5YS"};